// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Paper,
// //   TextField,
// //   IconButton,
// //   InputAdornment,
// // } from "@mui/material";
// // import { Icon } from "../../icons";
// // import { COLORS, TYPOGRAPHY } from "../../constants/color";

// // export default function WeeklyPlanningReport() {
// //   const [activeDay, setActiveDay] = useState(null);

// //   const COLS = {
// //     week: "160px",
// //     activity: 1,
// //     details: 1.4,
// //     material: 1.3,
// //     support: 1.1,
// //     remark: 1.2,
// //     action: "40px",
// //   };

// //   const StyledField = ({ sx = {}, ...props }) => (
// //   <TextField
// //     fullWidth
// //     variant="outlined"
// //     {...props}
// //     sx={{
// //       "& .MuiOutlinedInput-root": {
// //         height: "40px",
// //         borderRadius: "6px",
// //         fontSize: "13px",
// //       },
// //       "& .MuiOutlinedInput-notchedOutline": {
// //         borderColor: COLORS.LIGHT_SECONDARY,
// //       },
// //       "&:hover .MuiOutlinedInput-notchedOutline": {
// //         borderColor: COLORS.SECONDARY,
// //       },
// //       "& .MuiInputBase-input::placeholder": {
// //         color: COLORS.LIGHT_SECONDARY,
// //         opacity: 1,
// //         fontSize: "13px",
// //       },
// //       ...sx,
// //     }}
// //   />
// // );


// //   /* ---------- DUMMY DATA ---------- */
// //   const weekData = [
// //     {
// //       day: "Monday 5th Jan 26",
// //       entries: [
// //         {
// //           contractor: "Ram Reality",
// //           details: "2nd Slab Beam Bottom Shuttering",
// //           material: "Concrete Mixer",
// //           support: "2 Helpers",
// //           remark: "Initial work started",
// //         },
// //         {
// //           contractor: "Shiv Construction",
// //           details: "Column Reinforcement",
// //           material: "Steel Rods",
// //           support: "Supervisor",
// //           remark: "Material arranged",
// //         },
// //       ],
// //     },
// //     {
// //       day: "Tuesday 6th Jan 26",
// //       entries: [
// //         {
// //           contractor: "Ram Reality",
// //           details: "Slab Casting",
// //           material: "RMC",
// //           support: "Pump Operator",
// //           remark: "Casting scheduled",
// //         },
// //       ],
// //     },
// //   ];
// // const Field = ({ label, sx = {}, ...props }) => (
// //   <Box display="flex" flexDirection="column" flex={1}>
// //     <Typography
// //       sx={{
// //         fontSize: "12px",
// //         fontWeight: 500,
// //         color: COLORS.SECONDARY,
// //         mb: 0.5,
// //       }}
// //     >
// //       {label}
// //     </Typography>

// //     <TextField
// //       fullWidth
// //       variant="outlined"
// //       {...props}
// //       sx={{
// //         "& .MuiOutlinedInput-root": {
// //           height: props.multiline ? "auto" : "40px",
// //           borderRadius: "6px",
// //           fontSize: "13px",
// //         },
// //         "& .MuiOutlinedInput-notchedOutline": {
// //           borderColor: COLORS.LIGHT_SECONDARY,
// //         },
// //         "&:hover .MuiOutlinedInput-notchedOutline": {
// //           borderColor: COLORS.SECONDARY,
// //         },
// //         "& .MuiInputBase-input::placeholder": {
// //           color: COLORS.LIGHT_SECONDARY,
// //           opacity: 1,
// //           fontSize: "13px",
// //         },
// //         ...sx,
// //       }}
// //     />
// //   </Box>
// // );

// //   return (
// //     <Box p={1}>
// //       {/* ================= ORIGINAL HEADER (UNCHANGED) ================= */}
// //       <Box mb={2}>
// //         <Box display="flex" justifyContent="space-between" mb={1}>
// //           <Typography sx={{ ...TYPOGRAPHY.H2, color: COLORS.SECONDARY }}>
// //             Weekly Planning Report (WPR)
// //           </Typography>

// //           <IconButton size="small">
// //             <Icon name="close" />
// //           </IconButton>
// //         </Box>

// //         <Box display="flex" flexDirection="column" gap={0.4}>
// //           <Box display="flex" justifyContent="space-between">
// //             <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
// //               Project Name:{" "}
// //               <span style={{ color: COLORS.SECONDARY }}>
// //                 Hare Krishna Valley
// //               </span>
// //             </Typography>

// //             <Box display="flex" alignItems="center" gap={1}>
// //               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>Week:</Typography>
// //               <TextField
// //                 size="small"
// //                 placeholder="DD/MM/YYYY - DD/MM/YYYY"
// //                 InputProps={{
// //                   endAdornment: (
// //                     <InputAdornment position="end">
// //                       <IconButton size="small">
// //                         <Icon name="calendar" color={COLORS.SECONDARY} />
// //                       </IconButton>
// //                     </InputAdornment>
// //                   ),
// //                 }}
// //                 sx={{
// //                   width: "270px",
// //                   "& .MuiOutlinedInput-root": {
// //                     borderRadius: "6px",
// //                     height: "32px",
// //                     pr: 0.5,
// //                   },
// //                 }}
// //               />
// //             </Box>
// //           </Box>

// //           <Box display="flex" justifyContent="space-between">
// //             <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
// //               Address:{" "}
// //               <span style={{ color: COLORS.SECONDARY }}>
// //                 Pune, Maharashtra
// //               </span>
// //             </Typography>

// //             <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
// //               PMC:{" "}
// //               <span style={{ color: COLORS.SECONDARY }}>
// //                 Arconest Consultants
// //               </span>
// //             </Typography>
// //           </Box>

// //           <Box display="flex" justifyContent="space-between">
// //             <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
// //               Developer:{" "}
// //               <span style={{ color: COLORS.SECONDARY }}>
// //                 Vyankatesh Contracts
// //               </span>
// //             </Typography>

// //             <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
// //               Engineer:{" "}
// //               <span style={{ color: COLORS.SECONDARY }}>
// //                 Ashish Hase
// //               </span>
// //             </Typography>
// //           </Box>
// //         </Box>

// //         {/* HEADER BOTTOM LINE */}
// //         <Box
// //           mt={1.5}
// //           height="1px"
// //           sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
// //         />
// //       </Box>

// //       {/* ================= TABLE HEADER ================= */}
// //       <Box
// //         display="flex"
// //         alignItems="flex-start"
// //         sx={{
// //           py: 1.2,
// //           ...TYPOGRAPHY.H4,
// //           color: COLORS.TEXT,
// //           borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
// //         }}
// //       >
// //         {/* Week Days column with bottom border */}
// //         <FlexCell w={COLS.week} borderBottom="none">
// //           Week Days
// //         </FlexCell>

// //         <FlexCell flex={COLS.activity}>
// //           Targeted Activity <br /> Contractor/Vendor
// //         </FlexCell>
// //         <FlexCell flex={COLS.details}>Details</FlexCell>
// //         <FlexCell flex={COLS.material}>
// //           Material/Machinery <br /> requirements
// //         </FlexCell>
// //         <FlexCell flex={COLS.support}>Support Needed</FlexCell>
// //         <FlexCell flex={COLS.remark}>Remark</FlexCell>
// //         <FlexCell w={COLS.action} />

// //       </Box>

// //       {/* ================= TABLE BODY ================= */}
// //       {weekData.map((dayBlock) => (
// //         <Box key={dayBlock.day}>
// //           {dayBlock.entries.map((row, i) => (
// //             <FlexRow key={i}>
// //               {/* WEEK COLUMN (NO BORDER) */}
// //               <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
// //                 {i === 0 && (
// //                   <Typography
// //                     sx={{
// //                       ...TYPOGRAPHY.BODY_LARGE,
// //                       color: COLORS.SECONDARY,
// //                       wordBreak: "break-word",
// //                       whiteSpace: "normal",
// //                     }}
// //                   >
// //                     {dayBlock.day.split(" ")[0]}
// //                     <br />
// //                     {dayBlock.day.split(" ").slice(1).join(" ")}
// //                   </Typography>
// //                 )}
// //               </FlexCell>

// //               {/* DATA COLUMNS */}
// //               <FlexRowInner>
// //                 <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }}>
// //                   <Typography sx={{ 
// //                     color: COLORS.SECONDARY,
// //                     ...TYPOGRAPHY.BODY_LARGE,
// //                     wordBreak: "break-word",
// //                     whiteSpace: "normal",
// //                   }}>
// //                     {row.contractor}
// //                   </Typography>
// //                 </FlexCell>
// //                 <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }}>
// //                   <Typography sx={{ 
// //                     color: COLORS.SECONDARY,
// //                     ...TYPOGRAPHY.BODY_LARGE,
// //                     wordBreak: "break-word",
// //                     whiteSpace: "normal",
// //                   }}>
// //                     {row.details}
// //                   </Typography>
// //                 </FlexCell>
// //                 <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }}>
// //                   <Typography sx={{ 
// //                     color: COLORS.SECONDARY,
// //                     ...TYPOGRAPHY.BODY_LARGE,
// //                     wordBreak: "break-word",
// //                     whiteSpace: "normal",
// //                   }}>
// //                     {row.material}
// //                   </Typography>
// //                 </FlexCell>
// //                 <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }}>
// //                   <Typography sx={{ 
// //                     color: COLORS.SECONDARY,
// //                     ...TYPOGRAPHY.BODY_LARGE,
// //                     wordBreak: "break-word",
// //                     whiteSpace: "normal",
// //                   }}>
// //                     {row.support}
// //                   </Typography>
// //                 </FlexCell>
// //                 <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }}>
// //                   <Typography sx={{ 
// //                     color: COLORS.SECONDARY,
// //                     ...TYPOGRAPHY.BODY_LARGE,
// //                     wordBreak: "break-word",
// //                     whiteSpace: "normal",
// //                   }}>
// //                     {row.remark}
// //                   </Typography>
// //                 </FlexCell>
// //                 <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
// //                   <IconButton size="small">
// //                     <Icon name="edit" color={COLORS.SECONDARY} />
// //                   </IconButton>
// //                 </FlexCell>
// //               </FlexRowInner>
// //             </FlexRow>
// //           ))}
// // {activeDay === dayBlock.day && (
// //   <Box mt={2}>
// //     <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.SECONDARY, mb: 2 }}>
// //       Add New Entry for {dayBlock.day}
// //     </Typography>

// //     <Box display="flex" gap={2} mb={2}>
// //       <Field label="Contractor / Vendor" placeholder="Contractor / Vendor" />
// //       <Field label="Details" placeholder="Details" />
// //     </Box>

// //     <Box display="flex" gap={2} mb={2}>
// //       <Field label="Material / Machinery Req" placeholder="Material / Machinery Req" />
// //       <Field label="Support Needed" placeholder="Support Needed" />
// //     </Box>

// //     <Field
// //       label="Remark"
// //       placeholder="Remark Text Goes Here"
// //       multiline
// //       rows={3}
// //       sx={{ mb: 2 }}
// //     />

// //    <Box
// //   display="flex"
// //   justifyContent="space-between"
// //   alignItems="center"
// //   mt={2}
// // >
// //   {/* Cancel Button (Left) */}
// //   <Button
// //     onClick={() => setActiveDay(null)}
// //     startIcon={<Icon name="close2" />}
// //     sx={{
// //       textTransform: "none",
// //       color: COLORS.ERROR,
// //       fontWeight: 500,
// //     }}
// //   >
// //     Cancel
// //   </Button>

// //   {/* Add Button (Right) */}
// //   <Button
// //     startIcon={<Icon name="plus2" />}
// //     sx={{
// //       backgroundColor: COLORS.SECONDARY,
// //       color: "#fff",
// //       textTransform: "none",
// //       px: 2.5,
// //       "&:hover": {
// //         backgroundColor: COLORS.SECONDARY,
// //       },
// //     }}
// //   >
// //     Add New Entry for {activeDay}
// //   </Button>
// // </Box>

// //   </Box>
// // )}


// //           {/* ADD BUTTON */}
// //    {activeDay !== dayBlock.day && (
// //   <FlexEnd mt={1}>
// //     <Button
// //       size="small"
// //       startIcon={<Icon name="plus2" />}
// //       sx={{
// //         backgroundColor: COLORS.SECONDARY,
// //         color: "#fff",
// //         textTransform: "none",
// //       }}
// //       onClick={() => setActiveDay(dayBlock.day)}
// //     >
// //       Add New Entry
// //     </Button>
// //   </FlexEnd>
// // )}


          

// //           {/* SINGLE DAY SEPARATOR */}
// //           <Box
// //             mt={2}
// //             height="1px"
// //             sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
// //           />
// //         </Box>
// //       ))}
// //     </Box>
// //   );
// // }

// // /* ================= FLEX HELPERS ================= */

// // const FlexRow = ({ children, header }) => (
// //   <Box
// //     display="flex"
// //     alignItems="stretch"
// //     sx={{
// //       py: header ? 1.2 : 1,
// //       fontWeight: header ? 600 : 400,
// //     }}
// //   >
// //     {children}
// //   </Box>
// // );

// // const FlexCell = ({ children, flex, w, sx = {}, borderBottom = "none", ...props }) => (
// //   <Box 
// //     flex={flex} 
// //     width={w} 
// //     px={1} 
// //     sx={{ 
// //       ...TYPOGRAPHY.BODY_LARGE,
// //       borderBottom: borderBottom,
// //       ...sx
// //     }}
// //     {...props}
// //   >
// //     {children}
// //   </Box>
// // );

// // const FlexRowInner = ({ children, header }) => (
// //   <Box
// //     display="flex"
// //     flex={1}
// //     alignItems="stretch"
// //     sx={{
// //       borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
// //     }}
// //   >
// //     {children}
// //   </Box>
// // );

// // const FlexEnd = ({ children, mt }) => (
// //   <Box display="flex" justifyContent="flex-end" mt={mt}>
// //     {children}
// //   </Box>
// // );
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   IconButton,
//   InputAdornment,
//   CircularProgress,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   MenuItem,
//   useMediaQuery,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import { Icon } from "../../icons";
// import { COLORS, TYPOGRAPHY } from "../../constants/color";
// import axios from "axios";
// import { useAuth } from "../../context/authContext";
// import { url } from "../../constants/url";
// import AppToast from "../../components/AppToast";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { format } from "date-fns";

// export default function AddWPR() {
//   const { projectId } = useParams();
//   const { token, userData } = useAuth();
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery("(max-width: 768px)");

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [project, setProject] = useState(null);
//   const [companies, setCompanies] = useState([]);
//   const [selectedCompany, setSelectedCompany] = useState("");
  
//   // Week date state
//  const [weekStartDate, setWeekStartDate] = useState(
//   weekDates && weekDates.length > 0 ? weekDates[0].date : null
// );
// const [weekEndDate, setWeekEndDate] = useState(
//   weekDates && weekDates.length > 0 ? weekDates[5].date : null
// );
//   const [showDatePicker, setShowDatePicker] = useState(false);
  
//   // Toast state
//   const [toast, setToast] = useState({
//     open: false,
//     type: "success",
//     title: "",
//     message: "",
//   });
  
//   // Week data state
//   const [weekData, setWeekData] = useState([]);
//   const { 
//   weekType = "current", 
//   weekDates = [], 
//   projectName = "",
//   cardData 
// } = location.state || {};

//   // Add entry form state
//   const [newEntry, setNewEntry] = useState({
//     targetedActivity: "",
//     contractorVendor: "",
//     details: "",
//     materialMachineryRequirements: "",
//     supportNeeded: "",
//     remarks: "",
//   });
  
//   const [activeDay, setActiveDay] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [deleteDialog, setDeleteDialog] = useState({
//     open: false,
//     entryId: null,
//     dayIndex: null,
//     entryIndex: null,
//   });

//   const COLS = {
//     week: "160px",
//     activity: 1,
//     details: 1.4,
//     material: 1.3,
//     support: 1.1,
//     remark: 1.2,
//     action: "40px",
//   };

//   // Format date function (simple version)
//   const formatDate = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     const day = d.getDate();
//     const suffix = getDaySuffix(day);
//     const month = d.toLocaleString('default', { month: 'short' });
//     const year = d.getFullYear().toString().slice(-2);
//     const dayName = d.toLocaleString('default', { weekday: 'long' });
    
//     return `${dayName} ${day}${suffix} ${month} '${year}`;
//   };

//   // Format date for week column (Monday 5th Jan '26)
//   const formatDateForWeekColumn = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     const day = d.getDate();
//     const suffix = getDaySuffix(day);
//     const month = d.toLocaleString('default', { month: 'short' });
//     const year = d.getFullYear().toString().slice(-2);
//     const dayName = d.toLocaleString('default', { weekday: 'long' });
    
//     return `${dayName} ${day}${suffix} ${month} '${year}`;
//   };

//   // Format date for week header (DD/MM/YY - DD/MM/YY)
//   const formatDateForWeekHeader = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     return format(d, "dd/MM/yy");
//   };

//   const getDaySuffix = (day) => {
//     if (day >= 11 && day <= 13) return 'th';
//     switch (day % 10) {
//       case 1: return 'st';
//       case 2: return 'nd';
//       case 3: return 'rd';
//       default: return 'th';
//     }
//   };

//   // Fetch project data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         const config = {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//           },
//         };
        
//         // Fetch project details
//         const projectResponse = await axios.get(
//           `${url}/api/inhouse-projects/fetch-by/${projectId}`,
//           config
//         );
        
//         if (projectResponse.data.project) {
//           setProject(projectResponse.data.project);
          
//           // Fetch companies for PMC dropdown
//           const companiesResponse = await axios.get(
//             `${url}/api/company/fetch`,
//             config
//           );
          
//           if (companiesResponse.data.data) {
//             setCompanies(companiesResponse.data.data);
//             // Select first company by default
//             if (companiesResponse.data.data.length > 0) {
//               setSelectedCompany(companiesResponse.data.data[0]._id);
//             }
//           }
//         } else {
//           setError("Project not found");
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError("Failed to load project data. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     if (projectId && token) {
//       fetchData();
//     }
//   }, [projectId, token]);

//   // Initialize week data when dates are selected
//   useEffect(() => {
//     if (weekStartDate && weekEndDate) {
//       generateWeekData();
//     }
//   }, [weekStartDate, weekEndDate]);

//   // Generate week data structure
//   const generateWeekData = () => {
//     const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//     const weekDataArray = [];
    
//     const currentDate = new Date(weekStartDate);
    
//     for (let i = 0; i < 6; i++) {
//       const date = new Date(currentDate);
//       date.setDate(currentDate.getDate() + i);
      
//       weekDataArray.push({
//         day: days[i],
//         date: date,
//         formattedDate: formatDate(date),
//         entries: [],
//       });
//     }
    
//     setWeekData(weekDataArray);
//   };

//   // Handle week date selection (force Monday selection)
//  const handleWeekDateSelect = (date) => {
//   if (!date) return;
  
//   // Create date strings without timezone issues
//   const selectedDate = new Date(date);
  
//   // Get year, month, day without timezone conversion
//   const year = selectedDate.getFullYear();
//   const month = selectedDate.getMonth();
//   const day = selectedDate.getDate();
  
//   // Create Monday date (force it to be Monday)
//   const dayOfWeek = selectedDate.getDay();
//   let mondayDate = new Date(year, month, day);
  
//   // Adjust to Monday: Monday = 1, Tuesday = 2, etc.
//   if (dayOfWeek === 0) { // Sunday
//     mondayDate.setDate(mondayDate.getDate() - 6);
//   } else if (dayOfWeek > 1) { // Tuesday to Saturday
//     mondayDate.setDate(mondayDate.getDate() - (dayOfWeek - 1));
//   }
  
//   // Create Saturday (6 days after Monday)
//   const saturdayDate = new Date(mondayDate);
//   saturdayDate.setDate(mondayDate.getDate() + 5);
  
//   // Format dates for display (local time)
//   const formatForDisplay = (dateObj) => {
//     const d = new Date(dateObj);
//     return format(d, "dd/MM/yy");
//   };
  
//   // Format dates for backend (UTC, no time)
//   const formatForBackend = (dateObj) => {
//     const d = new Date(dateObj);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };
  
//   // Set state with Date objects
//   setWeekStartDate(mondayDate);
//   setWeekEndDate(saturdayDate);
//   setShowDatePicker(false);
  
//   showToast("success", "Week Selected", 
//     `Week: ${formatForDisplay(mondayDate)} - ${formatForDisplay(saturdayDate)}`);
  
//   // Debug log
//   console.log("Selected week:", {
//     display: `${formatForDisplay(mondayDate)} to ${formatForDisplay(saturdayDate)}`,
//     backend: {
//       start: formatForBackend(mondayDate),
//       end: formatForBackend(saturdayDate)
//     },
//     dates: {
//       monday: mondayDate,
//       saturday: saturdayDate
//     }
//   });
// };
//   // Handle adding new entry
//  const handleAddEntry = async () => {
//   if (!activeDay) return;
  
//   try {
//     setSaving(true);
    
//     const config = {
//       headers: {
//         Authorization: token ? `Bearer ${token}` : undefined,
//         "Content-Type": "application/json",
//       },
//     };
    
//     // Format dates
//     const weekStartStr = weekStartDate.toISOString().split('T')[0];
//     const weekEndStr = weekEndDate.toISOString().split('T')[0];
    
//     // Find the day index
//     const dayIndex = weekData.findIndex(day => day.formattedDate === activeDay);
//     if (dayIndex === -1) {
//       showToast("error", "Error", "Day not found");
//       return;
//     }
    
//     const selectedDay = weekData[dayIndex];
    
//     // Check if WPR exists for this week
//     let wprId = null;
//     let existingWPR = null;
    
//     try {
//       const existingWPRs = await axios.get(
//         `${url}/api/wpr/fetch-by-project/${projectId}`,
//         config
//       );
      
//       // Find existing WPR for this exact week
//       existingWPR = existingWPRs.data.wprs?.find(wpr => {
//         const wprStart = new Date(wpr.weekStartDate).toISOString().split('T')[0];
//         const wprEnd = new Date(wpr.weekEndDate).toISOString().split('T')[0];
//         return wprStart === weekStartStr && wprEnd === weekEndStr;
//       });
      
//       if (existingWPR) {
//         wprId = existingWPR._id;
        
//         // Check if this day already has entries in the existing WPR
//         const existingDayIndex = existingWPR.dailyEntries.findIndex(
//           day => day.day === selectedDay.day && 
//           new Date(day.date).toISOString().split('T')[0] === selectedDay.date.toISOString().split('T')[0]
//         );
        
//         if (existingDayIndex >= 0) {
//           // Day exists, add to existing entries
//           const updatedEntry = {
//             ...existingWPR.dailyEntries[existingDayIndex],
//             entries: [
//               ...existingWPR.dailyEntries[existingDayIndex].entries,
//               {
//                 targetedActivity: newEntry.targetedActivity,
//                 contractorVendor: newEntry.contractorVendor,
//                 details: newEntry.details,
//                 materialMachineryRequirements: newEntry.materialMachineryRequirements,
//                 supportNeeded: newEntry.supportNeeded,
//                 remarks: newEntry.remarks || "",
//               }
//             ]
//           };
          
//           // Update the specific day entry
//           const updateResponse = await axios.patch(
//             `${url}/api/wpr/add/${wprId}/daily-entry`,
//             {
//               day: selectedDay.day,
//               date: selectedDay.date.toISOString().split('T')[0],
//               entries: updatedEntry.entries,
//               action: "replace" // Replace all entries for this day
//             },
//             config
//           );
          
//           if (updateResponse.data.wpr) {
//             // Update local state
//             const updatedWeekData = [...weekData];
//             updatedWeekData[dayIndex].entries = [
//               ...updatedWeekData[dayIndex].entries,
//               {
//                 ...newEntry,
//                 _id: Date.now().toString()
//               }
//             ];
//             setWeekData(updatedWeekData);
//           }
//         } else {
//           // Day doesn't exist, add new day entry
//           const dailyEntryData = {
//             day: selectedDay.day,
//             date: selectedDay.date.toISOString().split('T')[0],
//             entries: [{
//               targetedActivity: newEntry.targetedActivity,
//               contractorVendor: newEntry.contractorVendor,
//               details: newEntry.details,
//               materialMachineryRequirements: newEntry.materialMachineryRequirements,
//               supportNeeded: newEntry.supportNeeded,
//               remarks: newEntry.remarks || "",
//             }]
//           };
          
//           const entryResponse = await axios.patch(
//             `${url}/api/wpr/add/${wprId}/daily-entry`,
//             dailyEntryData,
//             config
//           );
          
//           if (entryResponse.data.wpr) {
//             // Update local state
//             const updatedWeekData = [...weekData];
//             updatedWeekData[dayIndex].entries = [{
//               ...newEntry,
//               _id: Date.now().toString()
//             }];
//             setWeekData(updatedWeekData);
//           }
//         }
//       } else {
//         // Create new WPR with first entry
//        const formatDateForBackend = (date) => {
//   if (!date) return "";
//   const d = new Date(date);
//   const year = d.getFullYear();
//   const month = String(d.getMonth() + 1).padStart(2, '0');
//   const day = String(d.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// // Then use it when creating WPR
// const wprData = {
//   projectId,
//   title: `WPR - ${formatDateForWeekHeader(weekStartDate)} to ${formatDateForWeekHeader(weekEndDate)}`,
//   weekStartDate: formatDateForBackend(weekStartDate), // Use this
//   weekEndDate: formatDateForBackend(weekEndDate),
//           dailyEntries: [{
//             day: selectedDay.day,
//             date: selectedDay.date.toISOString().split('T')[0],
//             entries: [{
//               targetedActivity: newEntry.targetedActivity,
//               contractorVendor: newEntry.contractorVendor,
//               details: newEntry.details,
//               materialMachineryRequirements: newEntry.materialMachineryRequirements,
//               supportNeeded: newEntry.supportNeeded,
//               remarks: newEntry.remarks || "",
//             }]
//           }]
//         };
        
//         const newWPRResponse = await axios.post(
//           `${url}/api/wpr/add`,
//           wprData,
//           config
//         );
        
//         if (newWPRResponse.data.data?._id) {
//           wprId = newWPRResponse.data.data._id;
          
//           // Update local state
//           const updatedWeekData = [...weekData];
//           updatedWeekData[dayIndex].entries = [{
//             ...newEntry,
//             _id: Date.now().toString()
//           }];
//           setWeekData(updatedWeekData);
//         }
//       }
//     } catch (err) {
//       console.error("Error handling WPR:", err);
//       showToast("error", "Error", "Failed to save entry to server");
//       return;
//     }
    
//     // Reset form
//     setNewEntry({
//       targetedActivity: "",
//       contractorVendor: "",
//       details: "",
//       materialMachineryRequirements: "",
//       supportNeeded: "",
//       remarks: "",
//     });
//     setActiveDay(null);
    
//     showToast("success", "Success", "Entry added successfully!");
//   } catch (err) {
//     console.error("Error adding entry:", err);
//     showToast("error", "Error", err.response?.data?.message || "Failed to add entry");
//   } finally {
//     setSaving(false);
//   }
// };

//   // Handle deleting entry
//   const handleDeleteEntry = async (dayIndex, entryIndex, entryId) => {
//     try {
//       setSaving(true);
      
//       const config = {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//         },
//       };
      
//       // Remove from local state
//       const updatedWeekData = [...weekData];
//       updatedWeekData[dayIndex].entries.splice(entryIndex, 1);
//       setWeekData(updatedWeekData);
      
//       setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null });
//       showToast("success", "Success", "Entry deleted successfully!");
//     } catch (err) {
//       console.error("Error deleting entry:", err);
//       showToast("error", "Error", "Failed to delete entry");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Handle edit entry
//   const handleEditEntry = (dayIndex, entryIndex) => {
//     const entry = weekData[dayIndex].entries[entryIndex];
//     setActiveDay(weekData[dayIndex].formattedDate);
//     setNewEntry({
//       targetedActivity: entry.targetedActivity || "",
//       contractorVendor: entry.contractorVendor || "",
//       details: entry.details || "",
//       materialMachineryRequirements: entry.materialMachineryRequirements || "",
//       supportNeeded: entry.supportNeeded || "",
//       remarks: entry.remarks || "",
//     });
//   };

//   // Show toast function
//   const showToast = (type, title, message) => {
//     setToast({
//       open: true,
//       type,
//       title,
//       message,
//     });
//   };

//   // Close toast function
//   const closeToast = () => {
//     setToast({ ...toast, open: false });
//   };

//   // Custom DatePicker input component
//   const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
//     <TextField
//       size="small"
//       value={value}
//       onClick={onClick}
//       ref={ref}
//       placeholder="Select Monday Date"
//       InputProps={{
//         endAdornment: (
//           <InputAdornment position="end">
//             <IconButton size="small" onClick={onClick}>
//               <Icon name="calendar" color={COLORS.SECONDARY} />
//             </IconButton>
//           </InputAdornment>
//         ),
//       }}
//       sx={{
//         width: isMobile ? "100%" : "270px",
//         "& .MuiOutlinedInput-root": {
//           borderRadius: "6px",
//           height: "32px",
//           pr: 0.5,
//         },
//       }}
//       readOnly
//     />
//   ));

//   if (loading) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box p={2}>
//         <Alert severity="error">{error}</Alert>
//         <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
//           Go Back
//         </Button>
//       </Box>
//     );
//   }

//   if (!project) {
//     return (
//       <Box p={2}>
//         <Alert severity="warning">Project not found</Alert>
//         <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
//           Go Back
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box p={1}>
//         {/* ================= HEADER ================= */}
//         <Box mb={2}>
//           <Box display="flex" justifyContent="space-between" mb={1}>
//             <Typography sx={{ ...TYPOGRAPHY.H2, color: COLORS.SECONDARY }}>
//               Add Weekly Planning Report (WPR)
//             </Typography>

//             <IconButton size="small" onClick={() => navigate(-1)}>
//               <Icon name="close3" color={COLORS.ERROR} />
//             </IconButton>
//           </Box>

//           <Box display="flex" flexDirection="column" gap={0.4}>
//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Project Name:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.projectName}
//                 </span>
//               </Typography>

//               <Box display="flex" alignItems="center" gap={1} flexWrap={isMobile ? "wrap" : "nowrap"}>
//                 <Typography sx={TYPOGRAPHY.BODY_STANDARD}>Week:</Typography>
                
//                 {weekStartDate && weekEndDate ? (
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <TextField
//                       size="small"
//                       value={`${formatDateForWeekHeader(weekStartDate)} - ${formatDateForWeekHeader(weekEndDate)}`}
//                       onClick={() => setShowDatePicker(true)}
//                       sx={{
//                         width: isMobile ? "100%" : "200px",
//                         "& .MuiOutlinedInput-root": {
//                           borderRadius: "6px",
//                           height: "32px",
//                           pr: 0.5,
//                         },
//                       }}
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton size="small" onClick={() => setShowDatePicker(true)}>
//                               <Icon name="calendar" color={COLORS.SECONDARY} />
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                         readOnly: true,
//                       }}
//                     />
//                     <Button 
//                       size="small" 
//                       onClick={() => setShowDatePicker(true)}
//                       sx={{ textTransform: "none" }}
//                     >
//                       Change
//                     </Button>
//                   </Box>
//                 ) : (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       border: `1px solid ${COLORS.LIGHT_SECONDARY}`,
//                       borderRadius: 1,
//                       px: 1.2,
//                       py: 0.3,
//                       gap: 0.6,
//                       fontSize: TYPOGRAPHY.BODY_SMALL.fontSize,
//                       color: COLORS.PRIMARY,
//                       minWidth: 110,
//                       justifyContent: "space-between",
//                       cursor: "pointer",
//                       "&:hover": {
//                         borderColor: COLORS.SECONDARY,
//                       }
//                     }}
//                     onClick={() => setShowDatePicker(true)}
//                   >
//                     {weekStartDate ? formatDateForWeekHeader(weekStartDate) : "DD/MM/YYYY - DD/MM/YYYY"}
//                     <Icon name="calendar3" color={COLORS.SECONDARY} />
//                   </Box>
//                 )}
//               </Box>
//             </Box>

//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Address:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.siteAddress || "Pune, Maharashtra"}
//                 </span>
//               </Typography>

//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 PMC:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {companies.find(c => c._id === selectedCompany)?.name || "Arconest Consultants"}
//                 </span>
//               </Typography>
//             </Box>

//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Developer:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.developerName || "Vyankatesh Contracts"}
//                 </span>
//               </Typography>

//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Engineer:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.assignedEngineer?.name || project.assignedEngineerName || "Ashish Hase"}
//                 </span>
//               </Typography>
//             </Box>
//           </Box>

//           {/* HEADER BOTTOM LINE */}
//           <Box
//             mt={1.5}
//             height="1px"
//             sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
//           />
//         </Box>

//         {/* Show warning if week not selected */}
//         {!weekStartDate && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             Please select a week date to start adding entries
//           </Alert>
//         )}

//         {/* ================= TABLE HEADER ================= */}
//         {weekStartDate && (
//           <>
//             <Box
//               display="flex"
//               alignItems="flex-start"
//               sx={{
//                 py: 1.2,
//                 ...TYPOGRAPHY.H4,
//                 color: COLORS.TEXT,
//                 borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
//               }}
//             >
//               <FlexCell w={COLS.week} borderBottom="none">
//                 Week Days
//               </FlexCell>

//               <FlexCell flex={COLS.activity}>
//                 Targeted Activity <br /> Contractor/Vendor
//               </FlexCell>
//               <FlexCell flex={COLS.details}>Details</FlexCell>
//               <FlexCell flex={COLS.material}>
//                 Material/Machinery <br /> requirements
//               </FlexCell>
//               <FlexCell flex={COLS.support}>Support Needed</FlexCell>
//               <FlexCell flex={COLS.remark}>Remark</FlexCell>
//               <FlexCell w={COLS.action} />
//             </Box>

//             {/* ================= TABLE BODY ================= */}
//             {weekData.map((dayBlock, dayIndex) => (
//               <Box key={dayBlock.formattedDate}>
//                 {/* Render entries for this day */}
//                 {dayBlock.entries.map((row, entryIndex) => (
//                   <FlexRow key={entryIndex}>
//                     {/* WEEK COLUMN */}
//                     <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
//                       {entryIndex === 0 && (
//                         <Typography
//                           sx={{
//                             ...TYPOGRAPHY.BODY_LARGE,
//                             color: COLORS.SECONDARY,
//                             wordBreak: "break-word",
//                             whiteSpace: "normal",
//                           }}
//                         >
//                           {dayBlock.day.split(" ")[0]}
//                           <br />
//                           {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
//                         </Typography>
//                       )}
//                     </FlexCell>

//                     {/* DATA COLUMNS */}
//                     <FlexRowInner>
//                       <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }}>
//                         <Typography sx={{ 
//                           color: COLORS.SECONDARY,
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}>
//                           {row.contractorVendor}
//                         </Typography>
//                       </FlexCell>
//                       <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }}>
//                         <Typography sx={{ 
//                           color: COLORS.SECONDARY,
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}>
//                           {row.details}
//                         </Typography>
//                       </FlexCell>
//                       <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }}>
//                         <Typography sx={{ 
//                           color: COLORS.SECONDARY,
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}>
//                           {row.materialMachineryRequirements}
//                         </Typography>
//                       </FlexCell>
//                       <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }}>
//                         <Typography sx={{ 
//                           color: COLORS.SECONDARY,
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}>
//                           {row.supportNeeded}
//                         </Typography>
//                       </FlexCell>
//                       <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }}>
//                         <Typography sx={{ 
//                           color: COLORS.SECONDARY,
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}>
//                           {row.remarks}
//                         </Typography>
//                       </FlexCell>
//                       <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
//                         {/* <IconButton 
//                           size="small"
//                           onClick={() => handleEditEntry(dayIndex, entryIndex)}
//                         >
//                           <Icon name="edit" color={COLORS.SECONDARY} />
//                         </IconButton> */}
//                         <IconButton 
//                           size="small"
//                           onClick={() => setDeleteDialog({
//                             open: true,
//                             entryId: row._id,
//                             dayIndex: dayIndex,
//                             entryIndex: entryIndex,
//                           })}
//                         >
//                           <Icon name="close2" color={COLORS.ERROR} />
//                         </IconButton>
//                       </FlexCell>
//                     </FlexRowInner>
//                   </FlexRow>
//                 ))}

//                 {/* Show empty row if no entries and not in add mode */}
//                 {dayBlock.entries.length === 0 && activeDay !== dayBlock.formattedDate && (
//                   <FlexRow>
//                     <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
//                       <Typography
//                         sx={{
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           color: COLORS.SECONDARY,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}
//                       >
//                         {dayBlock.day.split(" ")[0]}
//                         <br />
//                         {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
//                       </Typography>
//                     </FlexCell>
//                     <FlexRowInner>
//                       <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} />
//                     </FlexRowInner>
//                   </FlexRow>
//                 )}

//                 {/* ADD ENTRY FORM - KEEP SAME UI AS ORIGINAL */}
//                 {activeDay === dayBlock.formattedDate && (
//                   <Box mt={2}>
//                     <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.SECONDARY, mb: 2 }}>
//                       Add New Entry for {dayBlock.formattedDate}
//                     </Typography>

//                     <Box display="flex" gap={2} mb={2}>
//                       <Field 
//                         label="Contractor / Vendor" 
//                         placeholder="Contractor / Vendor"
//                         value={newEntry.contractorVendor}
//                         onChange={(e) => setNewEntry({...newEntry, contractorVendor: e.target.value})}
//                       />
//                       <Field 
//                         label="Details" 
//                         placeholder="Details"
//                         value={newEntry.details}
//                         onChange={(e) => setNewEntry({...newEntry, details: e.target.value})}
//                       />
//                     </Box>

//                     <Box display="flex" gap={2} mb={2}>
//                       <Field 
//                         label="Material / Machinery Req" 
//                         placeholder="Material / Machinery Req"
//                         value={newEntry.materialMachineryRequirements}
//                         onChange={(e) => setNewEntry({...newEntry, materialMachineryRequirements: e.target.value})}
//                       />
//                       <Field 
//                         label="Support Needed" 
//                         placeholder="Support Needed"
//                         value={newEntry.supportNeeded}
//                         onChange={(e) => setNewEntry({...newEntry, supportNeeded: e.target.value})}
//                       />
//                     </Box>

//                     <Field
//                       label="Remark"
//                       placeholder="Remark Text Goes Here"
//                       multiline
//                       rows={3}
//                       value={newEntry.remarks}
//                       onChange={(e) => setNewEntry({...newEntry, remarks: e.target.value})}
//                       sx={{ mb: 2 }}
//                     />

//                     <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
//                       <Button
//                         onClick={() => {
//                           setActiveDay(null);
//                           setNewEntry({
//                             targetedActivity: "",
//                             contractorVendor: "",
//                             details: "",
//                             materialMachineryRequirements: "",
//                             supportNeeded: "",
//                             remarks: "",
//                           });
//                         }}
//                         startIcon={<Icon name="close2" />}
//                         sx={{
//                           textTransform: "none",
//                           color: COLORS.ERROR,
//                           fontWeight: 500,
//                         }}
//                         disabled={saving}
//                       >
//                         Cancel
//                       </Button>

//                       <Button
//                         startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <Icon name="plus2" />}
//                         sx={{
//                           backgroundColor: COLORS.SECONDARY,
//                           color: "#fff",
//                           textTransform: "none",
//                           px: 2.5,
//                           "&:hover": {
//                             backgroundColor: COLORS.SECONDARY,
//                           },
//                           "&:disabled": {
//                             backgroundColor: COLORS.LIGHT_SECONDARY,
//                           }
//                         }}
//                         onClick={handleAddEntry}
//                         disabled={saving}
//                       >
//                         {saving ? "Adding..." : `Add Entry for ${dayBlock.formattedDate}`}
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* ADD BUTTON */}
//                 {activeDay !== dayBlock.formattedDate && (
//                   <FlexEnd mt={1}>
//                     <Button
//                       size="small"
//                       startIcon={<Icon name="plus2" />}
//                       sx={{
//                         backgroundColor: COLORS.SECONDARY,
//                         color: "#fff",
//                         textTransform: "none",
//                       }}
//                       onClick={() => {
//                         setActiveDay(dayBlock.formattedDate);
//                         setNewEntry({
//                           targetedActivity: "",
//                           contractorVendor: "",
//                           details: "",
//                           materialMachineryRequirements: "",
//                           supportNeeded: "",
//                           remarks: "",
//                         });
//                       }}
//                       disabled={!weekStartDate}
//                     >
//                       Add New Entry
//                     </Button>
//                   </FlexEnd>
//                 )}

//                 {/* SINGLE DAY SEPARATOR */}
//                 <Box
//                   mt={2}
//                   height="1px"
//                   sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
//                 />
//               </Box>
//             ))}

//             {/* SUBMIT ALL BUTTON */}
//             {weekData.some(day => day.entries.length > 0) && (
//               <Box display="flex" justifyContent="center" mt={3}>
//                 <Button
//                   variant="contained"
//                   size="large"
//                   startIcon={<Icon name="save" />}
//                   sx={{
//                     backgroundColor: COLORS.PRIMARY,
//                     color: "#fff",
//                     textTransform: "none",
//                     px: 4,
//                     "&:hover": {
//                       backgroundColor: COLORS.SECONDARY,
//                     },
//                   }}
//                   onClick={async () => {
//                     try {
//                       setSaving(true);
//                       // Here you would save all entries to backend
//                       showToast("success", "Success", "Weekly Planning Report saved successfully!");
//                       setTimeout(() => navigate(-1), 2000);
//                     } catch (err) {
//                       showToast("error", "Error", "Failed to save report");
//                     } finally {
//                       setSaving(false);
//                     }
//                   }}
//                   disabled={saving}
//                 >
//                   {saving ? "Saving..." : "Submit Weekly Report"}
//                 </Button>
//               </Box>
//             )}
//           </>
//         )}

//         {/* Date Picker Dialog */}
//         <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)}>
//           <DialogTitle>Select Week Start Date (Monday)</DialogTitle>
//           <DialogContent>
//             <DatePicker
//               value={weekStartDate}
//               onChange={handleWeekDateSelect}
//               openTo="day"
//               views={['year', 'month', 'day']}
//               renderInput={(params) => (
//                 <TextField 
//                   {...params} 
//                   fullWidth 
//                   sx={{ mt: 2, display: 'none' }} 
//                   InputProps={{
//                     ...params.InputProps,
//                     readOnly: true,
//                   }}
//                 />
//               )}
//               shouldDisableDate={(date) => {
//                 // Only allow Mondays to be selected
//                 return date.getDay() !== 1;
//               }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setShowDatePicker(false)}>Cancel</Button>
//           </DialogActions>
//         </Dialog>

//         {/* DELETE CONFIRMATION DIALOG */}
//         <Dialog
//           open={deleteDialog.open}
//           onClose={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
//         >
//           <DialogTitle>Confirm Delete</DialogTitle>
//           <DialogContent>
//             <Typography>Are you sure you want to delete this entry?</Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button 
//               onClick={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
//               disabled={saving}
//             >
//               Cancel
//             </Button>
//             <Button 
//               onClick={() => handleDeleteEntry(deleteDialog.dayIndex, deleteDialog.entryIndex, deleteDialog.entryId)}
//               color="error"
//               disabled={saving}
//             >
//               {saving ? "Deleting..." : "Delete"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Toast Component */}
//         <AppToast
//           open={toast.open}
//           type={toast.type}
//           title={toast.title}
//           message={toast.message}
//           onClose={closeToast}
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// }

// /* ================= REUSABLE COMPONENTS ================= */

// const FlexRow = ({ children, header }) => (
//   <Box
//     display="flex"
//     alignItems="stretch"
//     sx={{
//       py: header ? 1.2 : 1,
//       fontWeight: header ? 600 : 400,
//     }}
//   >
//     {children}
//   </Box>
// );

// const FlexCell = ({ children, flex, w, sx = {}, borderBottom = "none", ...props }) => (
//   <Box 
//     flex={flex} 
//     width={w} 
//     px={1} 
//     sx={{ 
//       ...TYPOGRAPHY.BODY_LARGE,
//       borderBottom: borderBottom,
//       ...sx
//     }}
//     {...props}
//   >
//     {children}
//   </Box>
// );

// const FlexRowInner = ({ children, header }) => (
//   <Box
//     display="flex"
//     flex={1}
//     alignItems="stretch"
//     sx={{
//       borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
//     }}
//   >
//     {children}
//   </Box>
// );

// const FlexEnd = ({ children, mt }) => (
//   <Box display="flex" justifyContent="flex-end" mt={mt}>
//     {children}
//   </Box>
// );

// const Field = ({ label, sx = {}, ...props }) => (
//   <Box display="flex" flexDirection="column" flex={1}>
//     <Typography
//       sx={{
//         fontSize: "12px",
//         fontWeight: 500,
//         color: COLORS.SECONDARY,
//         mb: 0.5,
//       }}
//     >
//       {label}
//     </Typography>

//     <TextField
//       fullWidth
//       variant="outlined"
//       {...props}
//       sx={{
//         "& .MuiOutlinedInput-root": {
//           height: props.multiline ? "auto" : "40px",
//           borderRadius: "6px",
//           fontSize: "13px",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: COLORS.LIGHT_SECONDARY,
//         },
//         "&:hover .MuiOutlinedInput-notchedOutline": {
//           borderColor: COLORS.SECONDARY,
//         },
//         "& .MuiInputBase-input::placeholder": {
//           color: COLORS.LIGHT_SECONDARY,
//           opacity: 1,
//           fontSize: "13px",
//         },
//         ...sx,
//       }}
//     />
//   </Box>
// );
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Icon } from "../../icons";
import { COLORS, TYPOGRAPHY } from "../../constants/color";
import axios from "axios";
import { useAuth } from "../../context/authContext";
import { url } from "../../constants/url";
import AppToast from "../../components/AppToast";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import useFormPersistence from "../../hooks/useFormPersistence";

export default function AddWPR() {
  const { projectId } = useParams();
  const { token, userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  // Get week data from navigation state
  const { 
    weekStartDate: initialWeekStartDate, 
    weekEndDate: initialWeekEndDate,
    projectName: propProjectName 
  } = location.state || {};

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [project, setProject] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  
  // Week date state - Initialize from props
  const [weekStartDate, setWeekStartDate] = useState(
    initialWeekStartDate ? new Date(initialWeekStartDate) : null
  );
  const [weekEndDate, setWeekEndDate] = useState(
    initialWeekEndDate ? new Date(initialWeekEndDate) : null
  );
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  // Toast state
  const [toast, setToast] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });
  
  // Week data state with persistence
  const persistenceKey = `wpr-form-${projectId}-${weekStartDate ? format(weekStartDate, "yyyy-MM-dd") : "no-week"}`;
  const [weekData, setWeekData, clearPersistence] = useFormPersistence(persistenceKey, []);
  const [wprId, setWprId] = useState(null); // Add this to track existing WPR ID
  const [isExistingWPR, setIsExistingWPR] = useState(false); // Add this flag
  
  const [activeDay, setActiveDay] = useState(null);
  const [editingEntryId, setEditingEntryId] = useState(null); // Add this for editing

  // Add/Edit entry form state
  const newEntryPersistenceKey = `wpr-new-entry-${projectId}-${activeDay || 'no-day'}-${editingEntryId || 'new'}`;
  const [newEntry, setNewEntry, clearNewEntryPersistence] = useFormPersistence(newEntryPersistenceKey, {
    targetedActivity: "",
    contractorVendor: "",
    details: "",
    materialMachineryRequirements: "",
    supportNeeded: "",
    remarks: "",
  });
  const [saving, setSaving] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    entryId: null,
    dayIndex: null,
    entryIndex: null,
  });

  const COLS = {
    week: "160px",
    activity: 1,
    details: 1.4,
    material: 1.3,
    support: 1.1,
    remark: 1.2,
    action: "40px",
  };

  // Format date function
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = d.getDate();
    const suffix = getDaySuffix(day);
    const month = d.toLocaleString('default', { month: 'short' });
    const year = d.getFullYear().toString().slice(-2);
    const dayName = d.toLocaleString('default', { weekday: 'long' });
    
    return `${dayName} ${day}${suffix} ${month} '${year}`;
  };

  // Format date for week column (Monday 5th Jan '26)
  const formatDateForWeekColumn = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = d.getDate();
    const suffix = getDaySuffix(day);
    const month = d.toLocaleString('default', { month: 'short' });
    const year = d.getFullYear().toString().slice(-2);
    const dayName = d.toLocaleString('default', { weekday: 'long' });
    
    return `${dayName} ${day}${suffix} ${month} '${year}`;
  };

  // Format date for week header (DD/MM/YY - DD/MM/YY)
  const formatDateForWeekHeader = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return format(d, "dd/MM/yy");
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  // Fetch project data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const config = {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        };
        
        // Fetch project details
        const projectResponse = await axios.get(
          `${url}/api/inhouse-projects/fetch-by/${projectId}`,
          config
        );
        
        if (projectResponse.data.project) {
          setProject(projectResponse.data.project);
          
          // Fetch companies for PMC dropdown
          const companiesResponse = await axios.get(
            `${url}/api/company/fetch`,
            config
          );
          
          if (companiesResponse.data.data) {
            setCompanies(companiesResponse.data.data);
            // Select first company by default
            if (companiesResponse.data.data.length > 0) {
              setSelectedCompany(companiesResponse.data.data[0]._id);
            }
          }
          
          // If week dates are provided from props, fetch WPR data
          if (initialWeekStartDate && initialWeekEndDate) {
            const startDate = new Date(initialWeekStartDate);
            const endDate = new Date(initialWeekEndDate);
            setWeekStartDate(startDate);
            setWeekEndDate(endDate);
            await fetchWPRDataForWeek(startDate, endDate);
          } else {
            setLoading(false);
          }
        } else {
          setError("Project not found");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load project data. Please try again.");
        setLoading(false);
      }
    };
    
    if (projectId && token) {
      fetchData();
    }
  }, [projectId, token, initialWeekStartDate, initialWeekEndDate]);

  // Fetch WPR data for specific week
  const fetchWPRDataForWeek = async (startDate, endDate) => {
    try {
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      };
      
      // Fetch all WPRs for this project
      const wprResponse = await axios.get(
        `${url}/api/wpr/fetch-by-project/${projectId}`,
        config
      );
      
      if (wprResponse.data.wprs && wprResponse.data.wprs.length > 0) {
        // Find WPR for the selected week
        const weekStartStr = format(startDate, "yyyy-MM-dd");
        const weekEndStr = format(endDate, "yyyy-MM-dd");
        
        const existingWPR = wprResponse.data.wprs.find(wpr => {
          if (!wpr.weekStartDate || !wpr.weekEndDate) return false;
          
          const wprStart = format(new Date(wpr.weekStartDate), "yyyy-MM-dd");
          const wprEnd = format(new Date(wpr.weekEndDate), "yyyy-MM-dd");
          
          return wprStart === weekStartStr && wprEnd === weekEndStr;
        });
        
        if (existingWPR) {
          // WPR exists for this week - load it for editing
          setWprId(existingWPR._id);
          setIsExistingWPR(true);
          generateWeekDataWithEntries(existingWPR.dailyEntries || []);
        } else {
          // No existing WPR for this week - show empty form
          setIsExistingWPR(false);
          generateWeekData(startDate);
        }
      } else {
        // No WPRs exist for this project - show empty form
        setIsExistingWPR(false);
        generateWeekData(startDate);
      }
    } catch (err) {
      console.error("Error fetching WPR data:", err);
      // On error, generate empty week data
      setIsExistingWPR(false);
      generateWeekData(startDate);
    } finally {
      setLoading(false);
    }
  };

  // Generate week data with existing entries
  const generateWeekDataWithEntries = (dailyEntries) => {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const weekDataArray = [];
    
    const currentDate = new Date(weekStartDate);
    
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() + i);
      
      // Format date for comparison (YYYY-MM-DD)
      const dateStr = format(date, "yyyy-MM-dd");
      
      // Find entries for this specific date
      const dayEntry = dailyEntries.find(entry => {
        if (!entry.date) return false;
        
        const entryDate = new Date(entry.date);
        const entryDateStr = format(entryDate, "yyyy-MM-dd");
        
        // Match by both day name AND date string
        return entry.day === days[i] && entryDateStr === dateStr;
      });
      
      weekDataArray.push({
        day: days[i],
        date: date,
        formattedDate: formatDate(date),
        entries: dayEntry?.entries?.map(entry => ({
          _id: entry._id,
          targetedActivity: entry.targetedActivity || "",
          contractorVendor: entry.contractorVendor || "",
          details: entry.details || "",
          materialMachineryRequirements: entry.materialMachineryRequirements || "",
          supportNeeded: entry.supportNeeded || "",
          remarks: entry.remarks || "",
        })) || [],
      });
    }
    
    setWeekData(weekDataArray);
  };

  // Generate empty week data structure
  const generateWeekData = (startDate) => {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const weekDataArray = [];
    
    const currentDate = new Date(startDate);
    
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() + i);
      
      weekDataArray.push({
        day: days[i],
        date: date,
        formattedDate: formatDate(date),
        entries: [],
      });
    }
    
    setWeekData(weekDataArray);
  };

  // Handle week date selection (force Monday selection)
  const handleWeekDateSelect = async (date) => {
    if (!date) return;
    
    // Ensure selected date is a Monday
    const selectedDate = new Date(date);
    const dayOfWeek = selectedDate.getDay();
    const monday = new Date(selectedDate);
    
    // Adjust to Monday (day 1 in JS Date is Sunday = 0, Monday = 1)
    if (dayOfWeek === 0) {
      monday.setDate(selectedDate.getDate() - 6); // Sunday goes to previous Monday
    } else if (dayOfWeek > 1) {
      monday.setDate(selectedDate.getDate() - (dayOfWeek - 1));
    }
    
    // Calculate Saturday (6 days after Monday)
    const saturday = new Date(monday);
    saturday.setDate(monday.getDate() + 5);
    
    setWeekStartDate(monday);
    setWeekEndDate(saturday);
    setShowDatePicker(false);
    
    // Fetch WPR data for the newly selected week
    await fetchWPRDataForWeek(monday, saturday);
    
    showToast("success", "Week Selected", `Week: ${formatDateForWeekHeader(monday)} - ${formatDateForWeekHeader(saturday)}`);
  };

  // Handle adding/editing entry
  const handleAddEntry = async () => {
    if (!activeDay) return;
    
    try {
      setSaving(true);
      
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      };
      
      // Find the day index
      const dayIndex = weekData.findIndex(day => day.formattedDate === activeDay);
      if (dayIndex === -1) {
        showToast("error", "Error", "Day not found");
        return;
      }
      
      // If editing existing entry
      if (editingEntryId && wprId) {
        await updateExistingEntry(dayIndex);
      } else {
        // Add new entry
        await addNewEntry(dayIndex);
      }
    } catch (err) {
      console.error("Error saving entry:", err);
      showToast("error", "Error", err.response?.data?.message || "Failed to save entry");
    } finally {
      setSaving(false);
    }
  };

  // Add new entry
  const addNewEntry = async (dayIndex) => {
    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
      },
    };
    
    const weekStartStr = weekStartDate.toISOString().split('T')[0];
    const weekEndStr = weekEndDate.toISOString().split('T')[0];
    
    // Get or create WPR
    let currentWprId = wprId;
    
    if (!currentWprId) {
      // Create new WPR
      const wprData = {
        projectId,
        title: `WPR - ${formatDateForWeekHeader(weekStartDate)} to ${formatDateForWeekHeader(weekEndDate)}`,
        weekStartDate: weekStartStr,
        weekEndDate: weekEndStr,
        dailyEntries: [],
      };
      
      const wprResponse = await axios.post(
        `${url}/api/wpr/add`,
        wprData,
        config
      );
      
      if (wprResponse.data.data?._id) {
        currentWprId = wprResponse.data.data._id;
        setWprId(currentWprId);
        setIsExistingWPR(true); // Now we have an existing WPR
      }
    }
    
    if (currentWprId) {
      const selectedDay = weekData[dayIndex];
      
      const dailyEntryData = {
        day: selectedDay.day,
        date: selectedDay.date.toISOString().split('T')[0],
        entries: [{
          targetedActivity: newEntry.targetedActivity,
          contractorVendor: newEntry.contractorVendor,
          details: newEntry.details,
          materialMachineryRequirements: newEntry.materialMachineryRequirements,
          supportNeeded: newEntry.supportNeeded,
          remarks: newEntry.remarks || "",
        }]
      };
      
      const entryResponse = await axios.patch(
        `${url}/api/wpr/add/${currentWprId}/daily-entry`,
        dailyEntryData,
        config
      );
      
      if (entryResponse.data.wpr) {
        // Update local state with the new entry ID from backend
        const updatedWeekData = [...weekData];
        const newEntryFromBackend = entryResponse.data.wpr.dailyEntries
          ?.find(de => de.day === selectedDay.day && new Date(de.date).toDateString() === selectedDay.date.toDateString())
          ?.entries?.slice(-1)[0]; // Get the last added entry
        
        if (updatedWeekData[dayIndex].entries) {
          updatedWeekData[dayIndex].entries.push({
            ...newEntry,
            _id: newEntryFromBackend?._id || Date.now().toString()
          });
        } else {
          updatedWeekData[dayIndex].entries = [{
            ...newEntry,
            _id: newEntryFromBackend?._id || Date.now().toString()
          }];
        }
        setWeekData(updatedWeekData);
        
        // Reset form
        resetForm();
        
        showToast("success", "Success", "Entry added successfully!");
      }
    }
  };

  // Update existing entry
  const updateExistingEntry = async (dayIndex) => {
    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
      },
    };
    
    const updateData = {
      targetedActivity: newEntry.targetedActivity,
      contractorVendor: newEntry.contractorVendor,
      details: newEntry.details,
      materialMachineryRequirements: newEntry.materialMachineryRequirements,
      supportNeeded: newEntry.supportNeeded,
      remarks: newEntry.remarks || "",
    };
    
    const updateResponse = await axios.put(
      `${url}/api/wpr/update/${wprId}/entry/${editingEntryId}`,
      updateData,
      config
    );
    
    if (updateResponse.data.wpr) {
      // Update local state
      const updatedWeekData = [...weekData];
      const entryIndex = updatedWeekData[dayIndex].entries.findIndex(entry => entry._id === editingEntryId);
      
      if (entryIndex !== -1) {
        updatedWeekData[dayIndex].entries[entryIndex] = {
          ...updatedWeekData[dayIndex].entries[entryIndex],
          ...newEntry
        };
        setWeekData(updatedWeekData);
      }
      
      // Reset form
      resetForm();
      
      showToast("success", "Success", "Entry updated successfully!");
    }
  };

  // Handle deleting entry
  const handleDeleteEntry = async () => {
    const { dayIndex, entryIndex, entryId } = deleteDialog;
    
    try {
      setSaving(true);
      
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      };
      
      // Delete from backend if we have wprId and entryId
      if (wprId && entryId && !entryId.startsWith('temp-')) {
        await axios.delete(
          `${url}/api/wpr/delete/${wprId}/entry/${entryId}`,
          config
        );
      }
      
      // Remove from local state
      const updatedWeekData = [...weekData];
      updatedWeekData[dayIndex].entries.splice(entryIndex, 1);
      setWeekData(updatedWeekData);
      
      setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null });
      showToast("success", "Success", "Entry deleted successfully!");
    } catch (err) {
      console.error("Error deleting entry:", err);
      showToast("error", "Error", "Failed to delete entry");
    } finally {
      setSaving(false);
    }
  };

  // Handle edit entry click
  const handleEditEntry = (dayIndex, entryIndex) => {
    const entry = weekData[dayIndex].entries[entryIndex];
    setActiveDay(weekData[dayIndex].formattedDate);
    setEditingEntryId(entry._id);
    setNewEntry({
      targetedActivity: entry.targetedActivity || "",
      contractorVendor: entry.contractorVendor || "",
      details: entry.details || "",
      materialMachineryRequirements: entry.materialMachineryRequirements || "",
      supportNeeded: entry.supportNeeded || "",
      remarks: entry.remarks || "",
    });
  };

  // Reset form
  const resetForm = () => {
    if (clearNewEntryPersistence) clearNewEntryPersistence();
    setActiveDay(null);
    setEditingEntryId(null);
    setNewEntry({
      targetedActivity: "",
      contractorVendor: "",
      details: "",
      materialMachineryRequirements: "",
      supportNeeded: "",
      remarks: "",
    });
  };

  // Cancel edit/add
  const handleCancel = () => {
    resetForm();
  };

  // Show toast function
  const showToast = (type, title, message) => {
    setToast({
      open: true,
      type,
      title,
      message,
    });
  };

  // Close toast function
  const closeToast = () => {
    setToast({ ...toast, open: false });
  };

  // Save entire WPR
  const handleSaveWPR = async () => {
    try {
      setSaving(true);
      
      // If no entries, show warning
      if (!weekData.some(day => day.entries.length > 0)) {
        showToast("warning", "Warning", "No entries to save");
        return;
      }
      
      clearPersistence(); // Clear saved form data on success
      showToast("success", "Success", "Weekly Planning Report saved successfully!");
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      console.error("Error saving WPR:", err);
      showToast("error", "Error", "Failed to save report");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity="error">{error}</Alert>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );
  }

  if (!project) {
    return (
      <Box p={2}>
        <Alert severity="warning">Project not found</Alert>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box p={1}>
        {/* ================= HEADER ================= */}
        <Box mb={2}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography sx={{ ...TYPOGRAPHY.H2, color: COLORS.SECONDARY }}>
              {isExistingWPR ? "Weekly Planning Report (WPR)" : "Weekly Planning Report (WPR)"}
            </Typography>

            <IconButton size="small" onClick={() => navigate(-1)}>
              <Icon name="close3" color={COLORS.ERROR} />
            </IconButton>
          </Box>

          <Box display="flex" flexDirection="column" gap={0.4}>
            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Project Name:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {propProjectName || project.projectName}
                </span>
              </Typography>

              <Box display="flex" alignItems="center" gap={1} flexWrap={isMobile ? "wrap" : "nowrap"}>
                <Typography sx={TYPOGRAPHY.BODY_STANDARD}>Week:</Typography>
                
                {weekStartDate && weekEndDate ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                      size="small"
                      value={`${formatDateForWeekHeader(weekStartDate)} - ${formatDateForWeekHeader(weekEndDate)}`}
                      onClick={() => setShowDatePicker(true)}
                      sx={{
                        width: isMobile ? "100%" : "200px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "6px",
                          height: "32px",
                          pr: 0.5,
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => setShowDatePicker(true)}>
                              <Icon name="calendar" color={COLORS.SECONDARY} />
                            </IconButton>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                    <Button 
                      size="small" 
                      onClick={() => setShowDatePicker(true)}
                      sx={{ textTransform: "none" }}
                    >
                      Change
                    </Button>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: `1px solid ${COLORS.LIGHT_SECONDARY}`,
                      borderRadius: 1,
                      px: 1.2,
                      py: 0.3,
                      gap: 0.6,
                      fontSize: TYPOGRAPHY.BODY_SMALL.fontSize,
                      color: COLORS.PRIMARY,
                      minWidth: 110,
                      justifyContent: "space-between",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: COLORS.SECONDARY,
                      }
                    }}
                    onClick={() => setShowDatePicker(true)}
                  >
                    {weekStartDate ? formatDateForWeekHeader(weekStartDate) : "DD/MM/YYYY - DD/MM/YYYY"}
                    <Icon name="calendar3" color={COLORS.SECONDARY} />
                  </Box>
                )}
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Address:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.siteAddress || "Pune, Maharashtra"}
                </span>
              </Typography>

              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                PMC:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {companies.find(c => c._id === selectedCompany)?.name || "Arconest Consultants"}
                </span>
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Developer:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.developerName || "Vyankatesh Contracts"}
                </span>
              </Typography>

              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Engineer:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.assignedEngineer?.name || project.assignedEngineerName || "Ashish Hase"}
                </span>
              </Typography>
            </Box>
          </Box>

          {/* HEADER BOTTOM LINE */}
          <Box
            mt={1.5}
            height="1px"
            sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
          />
        </Box>

        {/* Show warning if week not selected */}
        {!weekStartDate && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Please select a week date to start adding entries
          </Alert>
        )}

        {/* ================= TABLE HEADER ================= */}
        {weekStartDate && (
          <>
            <Box
              display="flex"
              alignItems="flex-start"
              sx={{
                py: 1.2,
                ...TYPOGRAPHY.H4,
                color: COLORS.TEXT,
                borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
              }}
            >
              <FlexCell w={COLS.week} borderBottom="none">
                Week Days
              </FlexCell>

              <FlexCell flex={COLS.activity}>
                Targeted Activity <br /> Contractor/Vendor
              </FlexCell>
              <FlexCell flex={COLS.details}>Details</FlexCell>
              <FlexCell flex={COLS.material}>
                Material/Machinery <br /> requirements
              </FlexCell>
              <FlexCell flex={COLS.support}>Support Needed</FlexCell>
              <FlexCell flex={COLS.remark}>Remark</FlexCell>
              <FlexCell w={COLS.action} />
            </Box>

            {/* ================= TABLE BODY ================= */}
            {weekData.map((dayBlock, dayIndex) => (
              <Box key={dayBlock.formattedDate}>
                {/* Render entries for this day */}
                {dayBlock.entries.map((row, entryIndex) => (
                  <FlexRow key={entryIndex}>
                    {/* WEEK COLUMN */}
                    <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                      {entryIndex === 0 && (
                        <Typography
                          sx={{
                            ...TYPOGRAPHY.BODY_LARGE,
                            color: COLORS.SECONDARY,
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {dayBlock.day.split(" ")[0]}
                          <br />
                          {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
                        </Typography>
                      )}
                    </FlexCell>

                    {/* DATA COLUMNS */}
                    <FlexRowInner>
                      <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.contractorVendor}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.details}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.materialMachineryRequirements}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.supportNeeded}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.remarks}
                        </Typography>
                      </FlexCell>
                      <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                        <IconButton 
                          size="small"
                          onClick={() => handleEditEntry(dayIndex, entryIndex)}
                        >
                          <Icon name="Action3" color="#8ED081" />
                        </IconButton>
                        <IconButton 
                          size="small"
                          onClick={() => setDeleteDialog({
                            open: true,
                            entryId: row._id,
                            dayIndex: dayIndex,
                            entryIndex: entryIndex,
                          })}
                        >
                          <Icon name="close2" color={COLORS.ERROR} />
                        </IconButton>
                      </FlexCell>
                    </FlexRowInner>
                  </FlexRow>
                ))}

                {/* Show empty row if no entries and not in add/edit mode */}
                {dayBlock.entries.length === 0 && activeDay !== dayBlock.formattedDate && (
                  <FlexRow>
                    <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                      <Typography
                        sx={{
                          ...TYPOGRAPHY.BODY_LARGE,
                          color: COLORS.SECONDARY,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {dayBlock.day.split(" ")[0]}
                        <br />
                        {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
                      </Typography>
                    </FlexCell>
                    <FlexRowInner>
                      <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} />
                    </FlexRowInner>
                  </FlexRow>
                )}

                {/* ADD/EDIT ENTRY FORM */}
                {activeDay === dayBlock.formattedDate && (
                  <Box mt={2}>
                    <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.SECONDARY, mb: 2 }}>
                      {editingEntryId ? "Edit Entry for " : "Add New Entry for "}{dayBlock.formattedDate}
                    </Typography>

                    <Box display="flex" gap={2} mb={2}>
                      <Field 
                        label="Contractor / Vendor" 
                        placeholder="Contractor / Vendor"
                        value={newEntry.contractorVendor}
                        onChange={(e) => setNewEntry({...newEntry, contractorVendor: e.target.value})}
                      />
                      <Field 
                        label="Details" 
                        placeholder="Details"
                        value={newEntry.details}
                        onChange={(e) => setNewEntry({...newEntry, details: e.target.value})}
                      />
                    </Box>

                    <Box display="flex" gap={2} mb={2}>
                      <Field 
                        label="Material / Machinery Req" 
                        placeholder="Material / Machinery Req"
                        value={newEntry.materialMachineryRequirements}
                        onChange={(e) => setNewEntry({...newEntry, materialMachineryRequirements: e.target.value})}
                      />
                      <Field 
                        label="Support Needed" 
                        placeholder="Support Needed"
                        value={newEntry.supportNeeded}
                        onChange={(e) => setNewEntry({...newEntry, supportNeeded: e.target.value})}
                      />
                    </Box>

                    <Field
                      label="Remark"
                      placeholder="Remark Text Goes Here"
                      multiline
                      rows={3}
                      value={newEntry.remarks}
                      onChange={(e) => setNewEntry({...newEntry, remarks: e.target.value})}
                      sx={{ mb: 2 }}
                    />

                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                      <Box display="flex" gap={2}>
                        <Button
                          onClick={handleCancel}
                          startIcon={<Icon name="close2" />}
                          sx={{
                            textTransform: "none",
                            color: COLORS.ERROR,
                            fontWeight: 500,
                          }}
                          disabled={saving}
                        >
                          Cancel
                        </Button>

                        <Button
                          onClick={() => {
                            clearNewEntryPersistence();
                            setNewEntry({
                              targetedActivity: "",
                              contractorVendor: "",
                              details: "",
                              materialMachineryRequirements: "",
                              supportNeeded: "",
                              remarks: "",
                            });
                            showToast("info", "Fields Cleared", "The entry form has been reset.");
                          }}
                          startIcon={<Icon name="delete" />}
                          sx={{
                            color: COLORS.ERROR,
                            textTransform: "none",
                            fontWeight: 500,
                            border: `1px solid ${COLORS.ERROR}`,
                            borderRadius: "6px",
                            px: 2,
                            "&:hover": {
                              backgroundColor: `${COLORS.ERROR}15`,
                            }
                          }}
                        >
                          Clear Fields
                        </Button>
                      </Box>

                      <Button
                        startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <Icon name={editingEntryId ? "check" : "plus2"} />}
                        sx={{
                          backgroundColor: COLORS.SECONDARY,
                          color: "#fff",
                          textTransform: "none",
                          px: 2.5,
                          "&:hover": {
                            backgroundColor: COLORS.SECONDARY,
                          },
                          "&:disabled": {
                            backgroundColor: COLORS.LIGHT_SECONDARY,
                          }
                        }}
                        onClick={handleAddEntry}
                        disabled={saving}
                      >
                        {saving ? (editingEntryId ? "Updating..." : "Adding...") : (editingEntryId ? "Update Entry" : "Add New Entry")}
                      </Button>
                    </Box>
                  </Box>
                )}

                {/* ADD BUTTON */}
                {activeDay !== dayBlock.formattedDate && (
                  <FlexEnd mt={1}>
                    <Button
                      size="small"
                      startIcon={<Icon name="plus2" />}
                      sx={{
                        backgroundColor: COLORS.SECONDARY,
                        color: "#fff",
                        textTransform: "none",
                      }}
                      onClick={() => {
                        setActiveDay(dayBlock.formattedDate);
                        setEditingEntryId(null);
                        setNewEntry({
                          targetedActivity: "",
                          contractorVendor: "",
                          details: "",
                          materialMachineryRequirements: "",
                          supportNeeded: "",
                          remarks: "",
                        });
                      }}
                      disabled={!weekStartDate}
                    >
                      Add New Entry
                    </Button>
                  </FlexEnd>
                )}

                {/* SINGLE DAY SEPARATOR */}
                <Box
                  mt={2}
                  height="1px"
                  sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
                />
              </Box>
            ))}

            {/* SAVE/UPDATE BUTTON */}
            <Box display="flex" justifyContent="center" alignItems="center" gap={3} mt={3}>
              <Button
                onClick={() => {
                  const dateStr = weekStartDate ? format(weekStartDate, "yyyy-MM-dd") : "";
                  const keysToRemove = [];
                  for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && (key.includes(`wpr-form-${projectId}-${dateStr}`) || key.includes(`wpr-new-entry-${projectId}`))) {
                      keysToRemove.push(key);
                    }
                  }
                  keysToRemove.forEach(k => localStorage.removeItem(k));
                  showToast("info", "Drafts Cleared", "All weekly report drafts have been cleared.");
                  setTimeout(() => window.location.reload(), 1500);
                }}
                startIcon={<Icon name="delete" />}
                sx={{
                  color: COLORS.ERROR,
                  textTransform: "none",
                  border: `1px solid ${COLORS.ERROR}`,
                  px: 4,
                  py: 1,
                  borderRadius: "8px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: `${COLORS.ERROR}15`,
                  }
                }}
              >
                Clear All Drafts
              </Button>

              <Button
                variant="contained"
                size="large"
                startIcon={<Icon name="save" />}
                sx={{
                  backgroundColor: COLORS.PRIMARY,
                  color: "#fff",
                  textTransform: "none",
                  px: 4,
                  "&:hover": {
                    backgroundColor: COLORS.SECONDARY,
                  },
                }}
                onClick={handleSaveWPR}
                disabled={saving}
              >
                {saving ? "Saving..." : (isExistingWPR ? "Submit Weekly Progress Report" : "Submit Weekly Progress Report")}
              </Button>
            </Box>
          </>
        )}

        {/* Date Picker Dialog */}
        <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)}>
          <DialogTitle>Select Week Start Date (Monday)</DialogTitle>
          <DialogContent>
            <DatePicker
              value={weekStartDate}
              onChange={handleWeekDateSelect}
              openTo="day"
              views={['year', 'month', 'day']}
              minDate={userData?.role === "ENGINEER" ? new Date() : undefined}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  fullWidth 
                  sx={{ mt: 2, display: 'none' }} 
                  InputProps={{
                    ...params.InputProps,
                    readOnly: true,
                  }}
                />
              )}
              shouldDisableDate={(date) => {
                // Only allow Mondays to be selected
                return date.getDay() !== 1;
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDatePicker(false)}>Cancel</Button>
          </DialogActions>
        </Dialog>

        {/* DELETE CONFIRMATION DIALOG */}
        <Dialog
          open={deleteDialog.open}
          onClose={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this entry?</Typography>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
              disabled={saving}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleDeleteEntry}
              color="error"
              disabled={saving}
            >
              {saving ? "Deleting..." : "Delete"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Toast Component */}
        <AppToast
          open={toast.open}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          onClose={closeToast}
        />
      </Box>
    </LocalizationProvider>
  );
}

/* ================= REUSABLE COMPONENTS ================= */

const FlexRow = ({ children, header }) => (
  <Box
    display="flex"
    alignItems="stretch"
    sx={{
      py: header ? 1.2 : 1,
      fontWeight: header ? 600 : 400,
    }}
  >
    {children}
  </Box>
);

const FlexCell = ({ children, flex, w, sx = {}, borderBottom = "none", ...props }) => (
  <Box 
    flex={flex} 
    width={w} 
    px={1} 
    sx={{ 
      ...TYPOGRAPHY.BODY_LARGE,
      borderBottom: borderBottom,
      ...sx
    }}
    {...props}
  >
    {children}
  </Box>
);

const FlexRowInner = ({ children, header }) => (
  <Box
    display="flex"
    flex={1}
    alignItems="stretch"
    sx={{
      borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
    }}
  >
    {children}
  </Box>
);

const FlexEnd = ({ children, mt }) => (
  <Box display="flex" justifyContent="flex-end" mt={mt}>
    {children}
  </Box>
);

const Field = ({ label, sx = {}, ...props }) => (
  <Box display="flex" flexDirection="column" flex={1}>
    <Typography
      sx={{
        fontSize: "12px",
        fontWeight: 500,
        color: COLORS.SECONDARY,
        mb: 0.5,
      }}
    >
      {label}
    </Typography>

    <TextField
      fullWidth
      variant="outlined"
      {...props}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: props.multiline ? "auto" : "40px",
          borderRadius: "6px",
          fontSize: "13px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: COLORS.LIGHT_SECONDARY,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: COLORS.SECONDARY,
        },
        "& .MuiInputBase-input::placeholder": {
          color: COLORS.LIGHT_SECONDARY,
          opacity: 1,
          fontSize: "13px",
        },
        ...sx,
      }}
    />
  </Box>
);